import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import green from '@material-ui/core/colors/green';
import { withStyles } from '@material-ui/core/styles';
import Notifier, { openSnackbar } from '../notifier';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import S3Selector from './S3Selector';
import api from '../../api/backend'

const styles = theme => ({
    addCourse: {
        marginBottom: 20
    },
    card: {
        paddingTop: 84,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardContent: {
        flexGrow: 1,
    },
    form: {
        width: '100%', // Fix IE11 issue.
        marginTop: theme.spacing.unit,
    },
    drawer: {
        width: 500
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
});

class AddVideo extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { title: '', description: '', deactivated: false, show: false, path: '', loading: false }
    }

    uploadVideo = (event) => {
        event.preventDefault();
        const { courseId, onUploadCompleted } = this.props
        const { title, description, duration, file } = this.state
        this.setState({ loading: true })
        api.uploadVideo(courseId, file, title, description, Math.round(duration)).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                openSnackbar({ message: 'อับโหลดวีดีโอสำเร็จ' })
                if (onUploadCompleted) {
                    onUploadCompleted(json)
                }
                this.closeAndClear()
            } else {
                console.error('อับโหลดวีดีโอไม่สำเร็จ')
                openSnackbar({ message: 'อับโหลดวีดีโอไม่สำเร็จ' })
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
            openSnackbar({ message: 'ไม่สามารถเชื่อมต่อ service ได้' })
        })
    }

    createVideo = () => {
        const { onUploadCompleted, courseId } = this.props
        const { title, description, duration, path } = this.state
        api.createVideo({ title, description, path }, courseId).then(([response, json]) => {
            if (response.status === 200) {
                openSnackbar({ message: 'สร้างวีดีโอสำเร็จ' })
                if (onUploadCompleted) {
                    onUploadCompleted(json)
                }
                this.closeAndClear()
            } else {
                console.error('สร้างวีดีโอไม่สำเร็จ')
                openSnackbar({ message: 'สร้างวีดีโอไม่สำเร็จ' })
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
            openSnackbar({ message: 'ไม่สามารถเชื่อมต่อ service ได้' })
        })
    }

    closeAndClear = () => {
        this.setState({ title: '', description: '', deactivated: false, show: false, file: {}, loading: false })
    }

    render() {
        const { classes, courseId } = this.props
        const { title, description, deactivated, loading, path } = this.state
        return (
            <div>
                <Button onClick={() => this.setState({ show: true })}
                    variant="contained"
                    size="large"
                    color="primary"
                    fullWidth
                    className={classes.addCourse}
                    disabled={!courseId}
                >เพิ่มวีดีโอ</Button>

                <Dialog
                    open={this.state.show}
                    onClose={this.closeAndClear}
                    aria-labelledby="form-dialog-title"
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle id="form-dialog-title">แก้ไขผู้ใช้งาน</DialogTitle>
                    <DialogContent>
                        <Notifier />
                        <Grid container spacing={24}>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    id="title"
                                    name="title"
                                    label="หัวข้อ"
                                    fullWidth
                                    autoComplete="course title"
                                    value={title}
                                    onChange={(event) => { this.setState({ title: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    id="description"
                                    name="description"
                                    label="รายละเอียด"
                                    fullWidth
                                    multiline
                                    rows={5}
                                    autoComplete="course description"
                                    value={description}
                                    onChange={(event) => { this.setState({ description: event.target.value }) }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={<Checkbox color="secondary" name="deactivated" value={`${deactivated}`}
                                        onChange={(event) => { this.setState({ deactivated: event.target.value }) }} />}
                                    label="ยกเลิกวีดีโอ"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                {/* <TextField
                                    id="path"
                                    name="path"
                                    label="Path"
                                    fullWidth
                                    autoComplete="course path"
                                    value={path}
                                    onChange={(event) => { this.setState({ path: event.target.value }) }}
                                /> */}
                                <S3Selector selected={path} onCompleted={(value) => { if(value) this.setState({ path: value.value }) }}/>
                            </Grid>
                            {/* <Grid item xs={6}>
                                <input
                                    accept="video/mp4"
                                    style={{ display: 'none' }}
                                    id="outlined-button-file"
                                    type="file"
                                    onChange={(event) => {
                                        var video = document.createElement('video');
                                        video.preload = 'metadata';

                                        video.onloadedmetadata = () => {
                                            var duration = video.duration;
                                            this.setState({ duration: duration })
                                        }

                                        video.src = URL.createObjectURL(event.target.files[0]);
                                        console.log(event.target.files[0])
                                        this.setState({
                                            file: event.target.files[0]
                                        })
                                    }}
                                />
                                <label htmlFor="outlined-button-file">
                                    <Button variant="outlined" component="span" fullWidth size="large">
                                        เลือกไฟล์วีดีโอ
                                            </Button>
                                </label>
                                <br /> <br /> <br />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    id="fileName"
                                    name="fileName"
                                    label="ไฟล์ที่เลือก"
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    disabled={true}
                                    value={file.name}
                                />
                            </Grid> */}
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.closeAndClear} color="default" disabled={loading}>
                            ยกเลิก
                        </Button>
                        <Button onClick={this.createVideo} color="primary" disabled={loading}>
                            สร้างวีดีโอ
                        </Button>
                        {loading ? <CircularProgress size={24} className={classes.buttonProgress} /> : <React.Fragment>
                        </React.Fragment>}
                    </DialogActions>
                </Dialog>

                {/* <Drawer anchor="right" open={this.state.show} classes={{
                    paper: classes.drawer,
                }} onClose={this.closeAndClear}>

                    <Notifier />
                    <Card className={classes.card}>
                        <CardHeader
                            title={<Typography variant="title" gutterBottom>
                                เพิ่มวีดีโอ
                            </Typography>} />
                        <CardContent className={classes.cardContent}>
                            <form className={classes.form} onSubmit={this.uploadVideo}>
                                <Grid container spacing={24}>
                                    <Grid item xs={12}>
                                        <TextField
                                            required
                                            id="title"
                                            name="title"
                                            label="หัวข้อ"
                                            fullWidth
                                            autoComplete="course title"
                                            value={title}
                                            onChange={(event) => { this.setState({ title: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            id="description"
                                            name="description"
                                            label="รายละเอียด"
                                            fullWidth
                                            multiline
                                            rows={5}
                                            autoComplete="course description"
                                            value={description}
                                            onChange={(event) => { this.setState({ description: event.target.value }) }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControlLabel
                                            control={<Checkbox color="secondary" name="deactivated" value={`${deactivated}`}
                                                onChange={(event) => { this.setState({ deactivated: event.target.value }) }} />}
                                            label="ยกเลิกวีดีโอ"
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <input
                                            accept="video/mp4"
                                            style={{ display: 'none' }}
                                            id="outlined-button-file"
                                            type="file"
                                            onChange={(event) => {
                                                var video = document.createElement('video');
                                                video.preload = 'metadata';

                                                video.onloadedmetadata = () => {
                                                    var duration = video.duration;
                                                    this.setState({ duration: duration })
                                                }

                                                video.src = URL.createObjectURL(event.target.files[0]);
                                                console.log(event.target.files[0])
                                                this.setState({
                                                    file: event.target.files[0]
                                                })
                                            }}
                                        />
                                        <label htmlFor="outlined-button-file">
                                            <Button variant="outlined" component="span" fullWidth size="large">
                                                เลือกไฟล์วีดีโอ
                                            </Button>
                                        </label>
                                        <br /> <br /> <br />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            id="fileName"
                                            name="fileName"
                                            label="ไฟล์ที่เลือก"
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            disabled={true}
                                            value={file.name}
                                        />
                                    </Grid>
                                </Grid>
                                <div className={classes.wrapper}>
                                    <Button
                                        type="submit"
                                        variant="raised"
                                        color="primary"
                                        disabled={loading}
                                        className={classes.submit}
                                        size="large"
                                        fullWidth
                                    >
                                        สร้างวีดีโอ
                                    </Button>
                                    {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                                </div>
                            </form>
                        </CardContent>
                    </Card>
                </Drawer> */}
            </div>
        );
    }
}

export default withStyles(styles)(AddVideo);